import {getData} from "../api/get-data";

export const setOptionCart = (itemId, optionId, action, resolveHandler) => {
  getData({
    [`set_cart`]: {
      [`item_id`]: itemId,
      [`action`]: action,
      [`option`]: optionId,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
